export const AVATAR_COLORS = [
  'red.500',
  'blue.500',
  'green.500',
  'purple.500',
  'orange.500',
  'teal.500',
] as const

export const getAvatarColorById = (id: string) => {
  const hash = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}
